<template>
  <ReportLayoutModerno
    v-if="prefecture"
    id="genericReport"
    :prefecture="prefecture"
    :period="formatDateBr(startDate) + ' até ' + formatDateBr(endDate)"
  >
    <template v-slot:icon>mdi-gas-station</template>
    <template v-slot:title>RELATÓRIO DE ABASTECIMENTOS</template>
    
    <div class="overflow-x-auto">
      <table
      class="table"
      style="
        border-collapse: collapse;
        border: 1px solid rgb(214, 214, 214);
        border-top: 0;
        text-align: center;
        width: 100%;
        font-size: 12px;
      "
    >
      <thead>
        <tr style="border: 1px solid rgb(214, 214, 214); text-align: center">
          <th
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 3px;
              text-align: center;
              background: gray;
              color: #fff;
            "
          >
            Motorista
          </th>
          <th
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 3px;
              text-align: center;
              background: gray;
              color: #fff;
            "
          >
            Veículo
          </th>
          <th
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 3px;
              text-align: center;
              background: gray;
              color: #fff;
            "
          >
            Responsável pela Liberação
          </th>
          <th
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 3px;
              text-align: center;
              background: gray;
              color: #fff;
            "
          >
            Data e Hora
          </th>
          <th
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 3px;
              text-align: center;
              background: gray;
              color: #fff;
            "
          >
            Cupom Fiscal
          </th>
          <th
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 3px;
              text-align: center;
              background: gray;
              color: #fff;
            "
          >
            Km Anterior
          </th>
          <th
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 3px;
              text-align: center;
              background: gray;
              color: #fff;
            "
          >
            Km Atual
          </th>
          <th
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 3px;
              text-align: center;
              background: gray;
              color: #fff;
            "
          >
            Litros Abastecidos
          </th>
          <th
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 3px;
              text-align: center;
              background: gray;
              color: #fff;
            "
          >
            Média
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(value, index) in data" :key="index">
          <td
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 8px;
              text-align: center;
            "
          >
            {{ value.driver_name }}
          </td>
          <td
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 8px;
              text-align: center;
            "
            v-if="value.vehicle_id"
          >
            {{ value.brand_desc }} - {{ value.model_desc }} - {{ value.vehicle_board }}
          </td>
          <td
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 8px;
              text-align: center;
            "
            v-else
          ></td>
          <td
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 8px;
              text-align: center;
            "
          >
            {{ value.is_is_autorized ? value.authorizer.toUpperCase() : 'Sem autorização prévia'}}
          </td>
          <td
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 8px;
              text-align: center;
            "
          >
            {{ convertDateTime(value.datehour) }}
          </td>
          <td
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 8px;
              text-align: center;
            "
          >
            {{ value.supply_coupon }}
          </td>
          <td
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 8px;
              text-align: center;
            "
          >
            {{ value.last_km.toLocaleString('pt-BR') }}
          </td>
          <td
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 8px;
              text-align: center;
            "
          >
            {{ value.supply_km.toLocaleString('pt-BR') }}
          </td>
          <td
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 8px;
              text-align: center;
            "
          >
            {{ realMaskII(value.supply_liters_stocked.toFixed(3)) }}
          </td>
          <td
            style="
              border: 1px solid rgb(214, 214, 214);
              padding: 8px;
              text-align: center;
            "
          >
            {{ value.supply_liters_stocked > 0 
                ? `${((value.supply_km - value.last_km) / value.supply_liters_stocked).toFixed(2).toLocaleString("pt-BR")} KM/L`
                : '0 KM/L'
            }}
          </td>
        </tr>
      </tbody>
      </table>
    </div>
  </ReportLayoutModerno>
</template>

<script>
import helpers from "@/mixins/helpers";
import ReportLayoutModerno from "@/components/ReportLayoutModerno.vue";
export default {
  components: {
    ReportLayoutModerno,
  },
  props: ["data", "prefecture", "startDate", "endDate"],
  mixins: [helpers],
  mounted: {},
  methods: {
    initialize() {
      this.helpers;
    },
  },
};
</script>

<style scoped>
table {
  border-collapse: collapse;
  border: 1px solid rgb(17, 17, 17);
}
</style>
